/* FUSIFY ruimtepagina's: ruimtecheck, geurkiezer en geurdag. Werkt met fzx.js (FZX-helpers, fzxkeuze-event). */
(function () {
  var root = document.querySelector('.fzx.rm'); if (!root) return;
  var M = window.RM_MODELLEN || {}, ZAK = !!window.RM_ZAKELIJK;
  var prods = root.querySelector('.rm-prods'); if (prods) prods.style.setProperty('--n', prods.children.length);

  /* mobiel: producten boven de vouw, de geurwolk eronder */
  if (innerWidth < 750) { var w = root.querySelector('.rm-foto') || root.querySelector('.rm-wolk'); if (w && prods) prods.parentNode.insertBefore(w, prods.nextSibling) }

  /* ---------- ruimtecheck ---------- */
  var ck = root.querySelector('.rm-check');
  if (ck) {
    var CK = JSON.parse(ck.getAttribute('data-check') || '{}'), r = ck.querySelector('input[type=range]'), out = ck.querySelector('output'), q = function (k) { return ck.querySelector('[data-rc="' + k + '"]') };
    var reken = function () {
      var m2 = +r.value, f = 1;
      [].forEach.call(ck.querySelectorAll('input[type=checkbox]:checked'), function (c) { f *= +c.getAttribute('data-f') });
      var eff = m2 * f, keuze, waarom;
      if (eff <= 35) { keuze = 'pluggy'; waarom = 'Compact en direct in het stopcontact: ruim genoeg voor ' + m2 + ' m²' }
      else if (eff <= 90) { keuze = 'nobox'; waarom = 'Genoeg bereik voor ' + m2 + ' m², met snoer of tot 5 dagen draadloos' }
      else if (eff <= 190 || !ZAK) { keuze = 'flux'; waarom = eff > 190 ? 'Onze krachtigste diffuser voor thuis. Bij zo veel ruimte: overweeg er twee, verdeeld over de ruimte.' : 'De krachtigste diffuser voor thuis, tot 220 m²' }
      else { keuze = 'proffy'; waarom = 'Voor deze oppervlakte werkt een geurverspreider op de ventilatie het best: één apparaat voor de hele ruimte' }
      var m = M[keuze], ratio = Math.min(1, eff / m.m2), stand = ratio < .35 ? 'Laag' : ratio < .7 ? 'Midden' : 'Hoog';
      var max = CK.max_stand || 3; /* bv. huisdieren: nooit hoger dan laag/midden */
      if (max < 3 && stand === 'Hoog') stand = max === 1 ? 'Laag' : 'Midden';
      if (max < 2 && stand === 'Midden') stand = 'Laag';
      out.textContent = m2 + ' m²';
      q('naam').textContent = m.naam; q('why').textContent = waarom + '.';
      q('img').src = m.img; q('prijs').textContent = (m.vanaf ? 'vanaf ' : '') + m.prijs; q('btn').href = m.url;
      q('meter').style.width = Math.max(12, Math.round(ratio * 100)) + '%';
      q('stand').innerHTML = '<b>Stand: ' + stand + '</b>' + (m.ml ? ' · een geurpod van ' + m.ml + ' ml gaat ' + (stand === 'Hoog' ? 'korter dan ' : stand === 'Laag' ? 'langer dan ' : 'ongeveer ') + m.weken + ' weken mee' : ' · aansluiten op de ventilatie, bediening via de app');
      window.FZX && FZX.flash(ck.querySelector('.fzx-res'));
    };
    r.addEventListener('input', reken); ck.addEventListener('change', reken); reken();
  }

  /* ---------- geurkiezer ---------- */
  root.addEventListener('fzxkeuze', function (e) {
    if (e.detail.groep === 'geurtag') {
      var t = e.detail.waarde;
      [].forEach.call(root.querySelectorAll('.rm-geur__k'), function (k) {
        var past = !t || (' ' + k.getAttribute('data-tags') + ' ').indexOf(' ' + t + ' ') > -1;
        k.classList.toggle('uit', !past); k.classList.toggle('aan', !!t && past);
      });
    }
    if (e.detail.groep === 'dag') tekenDag(+e.detail.waarde);
  });

  /* ---------- geurdag ---------- */
  var dg = root.querySelector('.rm-dag'), D = dg ? JSON.parse(dg.getAttribute('data-dag')) : null;
  function tijd(u) { var h = Math.floor(u), m = Math.round((u - h) * 60); return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m }
  function tekenDag(i) {
    if (!D) return;
    var p = D.presets[i] || D.presets[0], spoor = dg.querySelector('.rm-dag__spoor'), lijst = dg.querySelector('.rm-dag__lijst'), uren = 0;
    spoor.innerHTML = p.momenten.map(function (m) { return '<span class="rm-dag__blok" data-s="' + m.stand + '" style="left:' + (m.van / 24 * 100) + '%;width:' + ((m.tot - m.van) / 24 * 100) + '%" title="' + m.label + '"></span>' }).join('');
    lijst.innerHTML = p.momenten.map(function (m) { uren += m.tot - m.van; return '<li><b>' + tijd(m.van) + '–' + tijd(m.tot) + '</b>' + m.label + '<i>' + ['', 'laag', 'midden', 'hoog'][m.stand] + '</i></li>' }).join('');
    dg.querySelector('.rm-dag__som').textContent = 'Samen ' + String(Math.round(uren * 10) / 10).replace('.', ',') + ' uur per dag. Dit zet je één keer in de app; daarna gaat het vanzelf.';
  }
  tekenDag(0);
})();
